import axios from "axios";
/**
 * Takes the Axios response and transforms it through an injected Zod Schema.
 *
 * For efficiency, these should be instantiated once and reused, otherwise
 * there will be a new instance of the transformer created for every request.
 * @param schema
 * @returns
 */
export const parseAxiosResponse = (schema) => {
    return [
        // Run the default transformResponse functions first.
        // This will do stuff like parse the response as JSON.
        ...axios.defaults.transformResponse,
        // Now run the "success with content" response through the Zod schema.
        (data, _headers, status) => (status === 200 ? schema.parse(data) : data),
    ];
};
//# sourceMappingURL=helpers.js.map